module.exports = __webpack_public_path__ + "img/qfgn.dcf2b868.png";